import { Modal, Typography, Checkbox } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "store/Reducers";
import { handleSetAdvertListFilter, handleSetIsShowAdvertPreview } from "../ClientStates";
import ProductDetails from "apps/RealState/Details/ProductDetails";
import { useParams } from "react-router-dom";
import { useState } from "react";

const { Text } = Typography;

const MobileSorting = () => {
  const dispatch = useDispatch();
  const { filter, isShowAdvertPreview } = useSelector((state: RootState) => state.realState);
  const params = useParams();
  const type = params["advertType"];
  
  const [selectedValue, setSelectedValue] = useState<string | null>(null);

  const applySorterFilter = (value: string) => {
    setSelectedValue(value); // Önceki seçimi kaldır ve yeni seçimi ata
    const [property, sortType] = value.split("_");

    if (["asc", "desc"].includes(sortType)) {
      const newFilter = {
        SortProperty: property,
        SortType: sortType,
      };
      const allFilter = { ...filter, ...newFilter };

      dispatch(handleSetAdvertListFilter({ filter: allFilter }));
    }
  };

  const options = [
    { value: "price_asc", label: "Fiyata göre (Önce en düşük)" },
    { value: "price_desc", label: "Fiyata göre (Önce en yüksek)" },
    { value: "insertDate_desc", label: "Tarihe göre (Önce en yeni ilan)" },
    { value: "insertDate_asc", label: "Tarihe göre (Önce en eski ilan)" },
    { value: "CityId_asc", label: "Adrese göre (A-Z)" },
    { value: "CityId_desc", label: "Adrese göre (Z-A)" },
  ];

  if (type === "vasita") {
    options.push(
      { value: "KM_asc", label: "Km göre (Önce en düşük)" },
      { value: "KM_desc", label: "Km göre (Önce en yüksek)" },
      { value: "Yıl_desc", label: "Yıla göre (Önce en yeni)" },
      { value: "Yıl_asc", label: "Yıla göre (Önce en eski)" }
    );
  }

  return (
    <>
      <div className="flex flex-col gap-2">
        {options.map((item) => (
          <Checkbox
            key={item.value}
            checked={selectedValue === item.value}
            onChange={() => applySorterFilter(item.value)}
            className="text-xs sm:text-sm"
          >
            <Text>{item.label}</Text>
          </Checkbox>
        ))}
      </div>

      <Modal
        open={isShowAdvertPreview}
        footer={false}
        onCancel={() => {
          dispatch(handleSetIsShowAdvertPreview({ status: false }));
        }}
        className="!w-full"
      >
        <ProductDetails />
      </Modal>
    </>
  );
};

export default MobileSorting;
